import { Check } from "lucide-react";
import { cn } from "@/modern/utils";
import { PROMOTE_STEPS, usePromotePanel } from "../context/PromotePanelContext";

const STEP_ROW_CLS = "flex min-w-0 items-center gap-2 rounded-md py-0.5";

export const StepIndicator = () => {
  const { currentStep, goToStep, canNavigateToStep } = usePromotePanel();

  return (
    <nav aria-label="Promote steps" className="flex items-center gap-1.5 px-0.5 py-0.5">
      {PROMOTE_STEPS.map((step, index) => {
        const isCompleted = index < currentStep;
        const isActive = index === currentStep;
        const interactive = canNavigateToStep(index);

        const content = (
          <>
            <div
              className={cn(
                "flex size-8 shrink-0 items-center justify-center rounded-full text-xs font-medium tabular-nums transition-colors",
                isActive && "bg-primary text-primary-foreground shadow-sm",
                isCompleted && "bg-primary/15 text-primary",
                !isCompleted && !isActive && "border border-border bg-muted/60 text-muted-foreground",
              )}
              aria-hidden
            >
              {isCompleted ? <Check className="size-3.5" strokeWidth={2.25} /> : index + 1}
            </div>
            <span
              className={cn(
                "truncate text-sm leading-tight",
                isActive ? "font-medium text-foreground" : isCompleted ? "text-foreground/85" : "text-muted-foreground",
              )}
            >
              {step.label}
            </span>
          </>
        );

        return (
          <div key={step.label} className="flex min-w-0 flex-1 items-center last:flex-none">
            {interactive ? (
              <button
                type="button"
                onClick={() => goToStep(index)}
                aria-current={isActive ? "step" : undefined}
                className={cn(
                  STEP_ROW_CLS,
                  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
                )}
              >
                {content}
              </button>
            ) : (
              <div className={STEP_ROW_CLS} aria-current={isActive ? "step" : undefined}>
                {content}
              </div>
            )}
            {index < PROMOTE_STEPS.length - 1 ? (
              <div
                className={cn(
                  "mx-2.5 h-0.5 min-w-3 flex-1 rounded-full",
                  isCompleted ? "bg-primary/80" : "bg-muted-foreground/40",
                )}
                aria-hidden
              />
            ) : null}
          </div>
        );
      })}
    </nav>
  );
};
